import { createContext } from 'react';
import { RentChargeDetail } from '@/custom-types';

export type AddRentChargeFormModalContextProps = {
  closeModal: () => void
  openModal: (rentChargeData?: RentChargeDetail) => void
  rentChargeData: RentChargeDetail | null
  isOpen: boolean
}

export const AddRentChargeFormModalContext = createContext<AddRentChargeFormModalContextProps | null>(null)